import {
  BitbucketWorkspacesResponse,
  BitbucketWorkspaceOptions
} from '@atlassiansox/asc-stargate';

import { useStargateClient } from './use-stargate-client';
import { AsyncResult, useAsync } from './use-async';

type UseBitbucketWorkspacesTypeOptions = {
  readonly makeRequest?: boolean;
} & BitbucketWorkspaceOptions;

export function useBitbucketWorkspaces({
  nextUrl,
  urlQuery,
  makeRequest
}: UseBitbucketWorkspacesTypeOptions): AsyncResult<BitbucketWorkspacesResponse | null> {
  const stargateClient = useStargateClient();

  return useAsync(
    () =>
      makeRequest
        ? stargateClient.bitbucketWorkspaces({ nextUrl, urlQuery })
        : Promise.resolve(null),
    [makeRequest]
  );
}
